export default "__VITE_ASSET__DDBK7WD6__"